import React from "react";
import { JhText } from "designPackages/textPackage";
import {
  MapPin,
  User,
  Wallet,
  Clock,
  Timer,
  SquareUserRound,
  Rocket
} from "lucide-react";
import { useHasPermission } from "queries/permissions/usePermissionQueries";
import { PERMISSIONS } from "utils/permissions";
import { checkPremiumJob } from "services/utils";
import dayjs from "dayjs";
import TAB_VALUES from "./tabValues";
import { useTabStore } from "zustandStores/tabStore";
interface JobCardMiddleSectionProps {
  job: any;
}

const JobCardMiddleSection: React.FC<JobCardMiddleSectionProps> = ({ job }) => {
  const { isAllowed: hasTeamsPermission } = useHasPermission(PERMISSIONS.TEAMS);
  const { activeTab } = useTabStore();
  const isPremiumJob = checkPremiumJob(job);
  const { action_on } = job;
  const actionOn = action_on || {};

  const getActionOnIcon = () => {
    if (actionOn.id === "BOOSTED") {
      return <Rocket size={16} color="var(--muted-foreground)" />;
    }
    if (actionOn.id === "UPGRADED") {
      return (
        <img
          src="/hire/premium_grey_icon.svg"
          alt="premium"
          className="w-4 h-4"
        />
      );
    }
    if (actionOn.id === "MADE_LIVE") {
      return <Clock size={16} color="var(--muted-foreground)" />;
    }
    return <Clock size={16} color="var(--muted-foreground)" />;
  };

  const actionOnIcon = getActionOnIcon();
  return (
    <div className="mt-2 mb-5">
      <JhText variant="emphasis2" color="foreground" className="mb-1.5">
        {job.job_title}
      </JhText>
      <div className="flex flex-col sm:flex-row flex-wrap gap-2 sm:gap-x-4 sm:gap-y-2">
        <div className="flex items-center gap-1">
          <MapPin size={16} color="var(--muted-foreground)" />
          <JhText variant="caption2" color="muted-foreground">
            {job.address}
          </JhText>
        </div>
        <div className="hidden sm:flex items-center gap-1">
          <User size={16} color="var(--muted-foreground)" />
          <JhText variant="caption2" color="muted-foreground">
            {job.no_of_openings} openings
          </JhText>
        </div>
        <div className="hidden sm:flex items-center gap-1">
          <Wallet size={16} color="var(--muted-foreground)" />
          <JhText variant="caption2" color="muted-foreground">
            {job.salary}
          </JhText>
        </div>
        {isPremiumJob && activeTab === TAB_VALUES.live && (
          <div className="hidden sm:flex items-center gap-1">
            <Timer size={16} color="var(--muted-foreground)" />
            <JhText variant="caption2" color="muted-foreground">
              Expires on {dayjs(job.hiring_end_date).format("D MMM, YY")}
            </JhText>
          </div>
        )}
        {hasTeamsPermission && job.posted_by && (
          <div className="flex items-center gap-1">
            <SquareUserRound size={16} color="var(--muted-foreground)" />
            <JhText variant="caption2" color="muted-foreground">
              Posted by {job.posted_by}
            </JhText>
          </div>
        )}
        {activeTab === TAB_VALUES.review && job.created_on && (
          <div className="flex items-center gap-1">
            <Clock size={16} color="var(--muted-foreground)" />
            <JhText variant="caption2" color="muted-foreground">
              {job.created_on}
            </JhText>
          </div>
        )}
        {(activeTab === TAB_VALUES.live || activeTab === TAB_VALUES.closed) &&
          actionOn.id && (
            <div className="flex items-center gap-1">
              {actionOnIcon}
              <JhText variant="caption2" color="muted-foreground">
                {actionOn.label}
              </JhText>
            </div>
          )}
      </div>
    </div>
  );
};

export default JobCardMiddleSection;
